import { useQuery } from "@tanstack/react-query";
import { listRewards } from "./rewardsApi";

export const useRewards = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["rewards"],
    queryFn: ({ signal }) => listRewards(signal),
  });

  return {
    rewards: data ?? [],
    isLoading,
  };
};
